// Owner in P4: piece 10 "enrichment" (docs/FILE-OWNERSHIP.md, "The P4 pieces").
// The feature's entry file (docs/CONTRACTS.md sections 16 and 22.6): `/enrichment`, one lazy chunk, created at the P4 freeze with a
// placeholder screen. The entry is `ownerOnly`; the route and the API refuse a member on their own. Paths carry ids and codes only (section 5).
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Sparkles } from 'lucide-react'
import type { Feature } from '../feature.ts'

export const feature: Feature = {
  app: (parent) => [createRoute({ getParentRoute: () => parent, path: '/enrichment', component: lazyRouteComponent(() => import('./EnrichmentScreen.tsx')) })],
  nav: [{ to: '/enrichment', label: 'nav.enrichment', icon: Sparkles, group: 'network', ownerOnly: true }],
}
